module.exports = __webpack_public_path__ + "static/ACABADO DE PISO-bb2c9310ba4170c3825d949c62b25a40.webp";